
export function keplr() {
  return window.keplr || null;
}


